import { z } from 'zod';

const FILL_FIELD = { message: 'Preencha o campo' };

export const nonemptySchema = z.string().nonempty(FILL_FIELD);
